/**
 * PACM
 */
export const Pacm = (function () {

    let init = function () {

        $('#pacm-member-table').bootstrapTable({
            formatNoMatches: function () {
                $(".loading-text").text("There are currently no members.");
                $(".animation-wrap").hide();
                return '';
            }
        });

        let groupID = $("#group-id").data("group");
        if (groupID != null) {
            // Get the groupd features from the PDX API
            let promise = pacmRequests.features(groupID);

            promise.then(function (response) {
                console.log(response);
                setFeatures(response.result.features);

            });
            promise.fail(function (response) {
                console.log('fail');
            });

        }
        pacm.addEventListeners();

    }

    return {
        init: init
    }

}());

/**
 * Loads the features from the PACM group and sets the inputs to true (sliders)
 * @param {*} features_array 
 */
function setFeatures(features_array) {

    for (let property in features_array) {
        //console.log(`${property}: ${features_array[property]}`);
        console.log(features_array[property].feature_id);
        document.getElementById(features_array[property].feature_id).checked = true;
    }
}


$(document).ready(function () {


    $('#pacm-create').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Pacm create');

        // get the pacm group name
        let group_name = document.getElementById('pacm-group-name').value;

        // get the list of members to be invited
        let members_list = $('#pacm-member-table').bootstrapTable('getData');
        let members = {
            "members": members_list
        }


        console.log(group_name);
        console.log(members_list);

        var myObj = {};

        // Loop over all the inputs within the feature groups in the UI
        // We want to add any that are checked - ensuring we set them into the correct feature group name index
        $('.myds-checkbox-input').each(function () {

            if (this.checked === true) {

                let ar = {
                    "feature_id": this.dataset.feature,
                    "feature_name": this.dataset.featureLabel
                }

                if (myObj.hasOwnProperty(this.dataset.featureGroupName)) {
                    myObj[this.dataset.featureGroupName].push(ar);
                } else {
                    myObj[this.dataset.featureGroupName] = [];
                    myObj[this.dataset.featureGroupName].push(ar);
                }
            }


        });

        if (Object.keys(myObj).length === 0) {
            Util.toggleAlert('#pacm-alert', "You need to add at least one feature", 'alert-warning');
            return;
        }

        let data = {
            "name": group_name,
            "feature_groups": myObj
        };

        console.log(data);

        let promise = pacmRequests.create(data, members_list);

        promise.then(function (response) {
            console.log('sent');
            console.log(response);
            window.location = '/circles-of-support'
        });
        promise.fail(function (response) {
            console.log('fail');
        });

    });

    pacm.addEventListeners();

    let groupID = $("#group-id").data("group");
    if (groupID != null) {
        // Get the groupd features from the PDX API
        let promise = pacmRequests.features(groupID);

        promise.then(function (response) {
            console.log(response);
            setFeatures(response.result.features);

        });
        promise.fail(function (response) {
            console.log('fail');
        });

    }


});

let pacmRequests = {


    activate: function () {
        let csrf = Util.getCSRF();
        let groupID = $("#group-id").data("group");

        return $.ajax({
            url: '/pacm/activate-group/' + groupID,
            type: 'post',
            data: '',
            headers: { 'x-csrf-token': csrf }
        });

    },

    delete: function () {
        let csrf = Util.getCSRF();
        let groupID = $("#group-id").data("group");

        return $.ajax({
            url: '/pacm/remove-group/' + groupID,
            type: 'delete',
            data: '',
            headers: { 'x-csrf-token': csrf }
        });
    },

    create: function (pacmGroup, memeberList) {
        let csrf = Util.getCSRF();
        let group = {
            "group": pacmGroup,
            "members": memeberList
        }

        return $.ajax({
            url: '/pacm/add-group',
            type: 'post',
            data: group,
            headers: { 'x-csrf-token': csrf }
        });
    },

    features: function (groupID) {
        return $.ajax({
            url: '/pacm/get-features/' + groupID,
            type: 'get'
        });

    },



};

let pacm = {


    addEventListeners: function () {

        // opens modal to resend invite when clicking the button
        $('#pacm-activate').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('clicked');
            let promise = pacmRequests.activate();

            promise.then(function (response) {
                console.log('sent');
                console.log(response);
                window.location = response.result;
            });
            promise.fail(function (response) {
                console.log('fail');
            });

        });

        $('#pacm-delete').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('clicked');
            let promise = pacmRequests.delete();

            promise.then(function (response) {
                console.log('sent');
                console.log(response);
                window.location = response.result;
            });
            promise.fail(function (response) {
                console.log('fail');
            });

        });

        $('#add_pacm_member').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('clicked');
            $('#manage-pacm-members').modal('show');


        });



        $('#myds-modal-right-button-manage-pacm-members').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log('clicked');
            // get the values if they exist
            // Validate if empty

            let memberName = document.getElementById('pacm-member-name').value;
            let memberEmail = document.getElementById('pacm-member-email').value;

            if (memberName === '' || memberEmail === '') {
                Util.toggleAlert('.alert', "The fields cannot be emtpy.", 'alert-warning');
                return;
            }

            if (!validateEmail(memberEmail)) {
                Util.toggleAlert('#myds-alert-modal', "Please enter a valid email address.", 'alert-warning');
                return;
            }


            $('#pacm-member-table').bootstrapTable('append', {
                name: memberName,
                email: memberEmail
            });

            document.getElementById('pacm-member-name').value = '';
            document.getElementById('pacm-member-email').value = '';
        });

        const validateEmail = (email) => {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        };






        $('#pacm-members').bootstrapTable({
            formatNoMatches: function () {
                $(".loading-text").text("There are currently no messages or alerts.");
                $(".animation-wrap").hide();
                return '';
            }
        });
        //opens modal 'Manage Invites' on click
        $('#myds-manage-invites').on('click', function (e) {
            e.preventDefault();
            $('#invites-modal').modal({
                backdrop: 'static',
                keyboard: false, //stops the modal from closing if clicking outside
                show: true
            });
        });

        // opens modal to resend invite when clicking the button
        $('.myds-card-button').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            Invites.openResendModal(this);
        });

        //opens modal to resend invite when clicking the card
        $('.myds-card-person').on('click', function (e) {
            e.preventDefault();

            let button = $(this).find('.myds-card-button');
            Invites.openResendModal(button);
        });

        var urlInvite = window.location.pathname.split('/');
        urlInvite = 'circle-of-support/' + urlInvite[urlInvite.length - 1];

        $('.send').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var promise = Invites.send(urlInvite);
            promise.done(function (response) {
                //reload page
                location.reload();
            }).fail(function (error) {
                //display error saying one of the invites exists and remove the row from the modal
                Util.toggleAlert("#myds-alert-modal", error.responseJSON.message, 'alert-warning', 9000);
            });
        });

        $('.resend').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var promise = Invites.resend(urlInvite);
            promise.done((success) => {
                $('#re-invites-modal').modal('hide');
                //reload page
                location.reload();
            }).fail((error) => {
                //display error saying one of the invites exists and remove the row from the modal
                Util.toggleAlert('#myds-alert-resend-modal', error.responseJSON.message, 'alert-warning', 9000);
            });
        });

    }


};



